import BaseAPIService from './BaseAPIService';
import notificationsGql from '../graphql/queries/notifications.gql';
import notificationSourcesGql from '../graphql/queries/notificationSources.gql';
import newNotificationGql from '../graphql/subscriptions/newNotification.gql';

export default class ActivityService extends BaseAPIService {
	constructor() {
		super();
	}

	async getNotifications(args) {
		const { next, previous, limit, actors } = args;
		const query = notificationsGql;
		const variables = {
			next,
			previous,
			limit: limit || 10,
			actors: actors || [],
		};
		const result = await this.query({
			query,
			variables,
			fetchPolicy: 'network-only'
		});
		return result.data.notifications;
	}

	async getNotificationSources() {
		const query = notificationSourcesGql;
		const result = await this.query({
			query,
		});
		return result.data.notificationSources;
	}

	subscribeNewNotifications() {
		const query = newNotificationGql;
		return this.subscribe({
			query,
		});
	}
}
